<template>
  <div>
    <h1>Métricas Mailing</h1>
    <!-- <h2>Servicio manual para envío de emails</h2> -->
    <div class="col-lg-10 col-12 form_mailing">

      <!-- Botones para filtrar contenido de métricas -->
      <!-- <div class="btns_content">
        <span>Mostrar:</span>
        <button
          @click="btnContent = 1"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ btn_selected: btnContent == 1 }"
        >
          Total
        </button>
        <button
          @click="btnContent = 2, fileName = 'Métricas-Moteros'"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ btn_selected: btnContent == 2 }"
        >
          Moteros
        </button>
        <button
          @click="btnContent = 3, fileName = 'Métricas-Lubricadores'"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ btn_selected: btnContent == 3 }"
        >
          Lubricadores
        </button>
        <button
          @click="btnContent = 4, fileName = 'Métricas-Distribuidores'"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ btn_selected: btnContent == 4 }"
        >
          Por distribuidor
        </button>
      </div> -->
      <!-- Fin botones para filtrar contenido de métricas -->

      <!-- Inicio tabla de métricas Totales -->
      <table v-if="btnContent == 1" class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Fecha de envío</th>
            <th scope="col">Cantidad de envíos</th>
            <th scope="col">Impresiones</th>
            <th scope="col">Clickeados</th>
            <th scope="col">Rebotados</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in metricsEmails" :key="item.id">
            <td><b>{{ item.date }}</b></td>
            <td><b>{{ item.total_sent.toLocaleString() }}</b></td>
            <td><b>{{ item.total_open.toLocaleString() }}</b></td>
            <td><b>{{ item.total_clicked.toLocaleString() }}</b></td>
            <td><b>{{ item.total_bounced.toLocaleString() }}</b></td>
            <td 
              style="cursor:pointer;" 
              @click="showChartData(item)"
              :class="{ 'selected': item === selectedData }"
            >
              <b>{{ 'Ver datos en gráfica' }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Fin tabla de métricas Totales -->

      <!-- Inicio tabla de métricas Moteros -->
      <table v-else-if="btnContent == 2" class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Fecha de envío</th>
            <th scope="col">Cantidad de envíos</th>
            <th scope="col">Emails abiertos</th>
            <th scope="col">Clickeados</th>
            <th scope="col">Rebotados</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in metricsEmails" :key="item.id">
            <td><b>{{ item.date }}</b></td>
            <td><b>{{ item.sent_bikers }}</b></td>
            <td><b>{{ item.open_bikers }}</b></td>
            <td><b>{{ item.clicked_bikers }}</b></td>
            <td><b>{{ item.total_bounced }}</b></td>
            <td 
              style="cursor:pointer;" 
              @click="showChartData(item)"
              :class="{ 'selected': item === selectedData }"
            >
              <b>{{ 'Ver datos en gráfica' }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Fin tabla de métricas Moteros -->

      <!-- Inicio tabla de métricas Lubricadores -->
      <table v-else-if="btnContent == 3" class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Fecha de envío</th>
            <th scope="col">Cantidad de envíos</th>
            <th scope="col">Emails abiertos</th>
            <th scope="col">Clickeados</th>
            <th scope="col">Rebotados</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in metricsEmails" :key="item.id">
            <td><b>{{ item.date }}</b></td>
            <td><b>{{ item.sent_lubricators }}</b></td>
            <td><b>{{ item.open_lubricators }}</b></td>
            <td><b>{{ item.clicked_lubricators }}</b></td>
            <td><b>{{ item.total_bounced }}</b></td>
            <td 
              style="cursor:pointer;" 
              @click="showChartData(item)"
              :class="{ 'selected': item === selectedData }"
            >
              <b>{{ 'Ver datos en gráfica' }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Fin tabla de métricas Lubricadores -->

      <!-- Inicio tabla de métricas por Distribuidor -->
      <table v-else class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Fecha de envío</th>
            <th scope="col">Distribuidor</th>
            <th scope="col">Cantidad de envíos</th>
            <th scope="col">Emails abiertos</th>
            <th scope="col">Clickeados</th>
            <th scope="col">Rebotados</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in metricsEmails" :key="item.id">
            <td><b>{{ item.date }}</b></td>
            <td><b>{{ item.distributor_name }}</b></td>
            <td><b>{{ item.total_sent }}</b></td>
            <td><b>{{ item.total_open }}</b></td>
            <td><b>{{ item.total_clicked }}</b></td>
            <td><b>{{ item.total_bounced }}</b></td>
            <td 
              style="cursor:pointer;" 
              @click="showChartData(item)"
              :class="{ 'selected': item === selectedData }"
            >
              <b>{{ 'Ver datos en gráfica' }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Fin tabla de métricas por Distribuidor -->

      <button
        v-if="metricsEmails.length > 0"
        @click="downloadExcel()"
        type="button"
        class="btn btn-success"
        style="margin:25px;"
      >
        Descargar en Excel
      </button>

      <!-- Gráficas -->
      <div v-if="dataLoaded && metricsEmails.length > 0" class="chart-container">
        <div style="width:100%; display:flex;">
          <button
            @click="updateChart()"
            type="button"
            class="view_total"
          >
            <b>Ver total</b>
          </button>
        </div>
        <v-chart class="chart" :option="option" />
      </div>

    </div>
  </div>
</template>
  
<script>
  import axios from 'axios';
  import * as XLSX from 'xlsx';

  // Importaciones para las graficas
  import { use } from "echarts/core";
  import { CanvasRenderer } from "echarts/renderers";
  import { BarChart } from "echarts/charts";
  import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    DataZoomComponent,
  } from "echarts/components";
  import VChart, { THEME_KEY } from "vue-echarts";

  use([
    CanvasRenderer,
    BarChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    DataZoomComponent,
  ]);
  
  export default {
    name: "emailMetrics",

    components: {
      VChart
    },
    provide: {
      [THEME_KEY]: "dark"
    },
    
    data(){
      return{
        btnContent: 1,

        // Métricas
        metricsEmails: [],
        fileName: "Métricas-Totales",
        selectedData: null,

        totalSent: 0,
        totalOpen: 0,
        totalClicked: 0,
        totalBounced: 0,

        dataLoaded: false,

        // Estructura de la gráfica de métricas
        option: {
          title: {
            text: "Métricas totales correos electrónicos",
            left: "center"
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            orient: "horizontal",
            left: "center",
            data: [
              "Enviados",
              "Impresiones",
              "Clickeados",
              "Rebotados",
            ]
          },
          xAxis: {
            type: "category",
            data: [
              "Total enviados",
              "Impresiones",
              "Clickeados",
              "Rebotados",
            ]
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "Métricas correos electrónicos",
              type: "bar",
              data: [
                this.totalSent, 
                this.totalOpen, 
                this.totalClicked, 
                this.totalBounced, 
              ],
              emphasis: {
                focus: "series"
              }
            }
          ]
        }
      };
    },

    methods:{
      getMetrics() {
        // Se realiza la petición al back para obtener las métricas
        axios
          .get('superAdmin/get/metrics')
          .then((response) => {
            if (response.data.cod == 0) {
              this.metricsEmails = response.data.data;
              // console.log('this.metricsEmails ', JSON.stringify(this.metricsEmails));
              this.totalSent = this.metricsEmails.reduce((total, item) => total + item.total_sent, 0);
              this.totalOpen = this.metricsEmails.reduce((total, item) => total + item.total_open, 0);
              this.totalClicked = this.metricsEmails.reduce((total, item) => total + item.total_clicked, 0);
              this.totalBounced = this.metricsEmails.reduce((total, item) => total + item.total_bounced, 0);
              this.updateChart();
            } else {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      updateChart() {
        // Actualiza la gráfica con los valores totales de las métricas
        this.option.series[0].data = [
          this.totalSent, 
          this.totalOpen, 
          this.totalClicked, 
          this.totalBounced, 
        ];
        this.option.title.text = "Métricas totales correos electrónicos";
        setTimeout(() => {
          this.dataLoaded = true;
        }, 500);
        this.selectedData = null;
      },
      downloadExcel(){
        var dataDownload = [];

        this.metricsEmails.forEach((item) => {
          dataDownload.push({
            Fecha_envío: item.date, 
            Distribuidor: item.distributor_name, 
            Cantidad_enviados: item.total_sent, 
            Abiertos: item.total_open, 
            Clickeados: item.total_clicked,
            Rebotados: item.total_bounced,
          });
        });

        this.$swal({
          icon: 'question',
          title: 'Descargar Métricas',
          text: "¿Estás seguro que quieres descargar las métricas?",
          confirmButtonText: 'Sí, descargar',
          confirmButtonColor: '#28a745',
          showCancelButton: true,
          cancelButtonText: "No, gracias",
          cancelButtonColor: '#dc3545',
        }).then((result) => {
          if (result.isConfirmed) {
            let data = XLSX.utils.json_to_sheet(dataDownload);
            const workbook = XLSX.utils.book_new();
            // const filename = 'Métricas';
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            XLSX.writeFile(workbook, `${this.fileName}.xlsx`);
          }
        });
      },
      showChartData(item) {
        this.selectedData = item;
        this.option.series[0].data = [
          this.selectedData.total_sent, 
          this.selectedData.total_open, 
          this.selectedData.total_clicked, 
          this.selectedData.total_bounced, 
        ];
        this.option.title.text = "Fecha de envío: " + this.selectedData.date;
      },
    },
    watch:{

    },
    mounted(){
      this.getMetrics();
    }
  };
</script>
  
<style scoped>
  h1, h2{
    color: black;
    font-family: "GothamBoldItalic";
  }
  .form_mailing{
    margin: auto;
  }
  #exampleFormControlTextarea1{
    resize: none;
  }
  .btns_content{
    display: block;
    padding: 15px 0px;
  }
  .btns_content > button{
    margin: 15px 5px;
  }
  .btns_content > span{
    color: #595959;
    padding: 5px;
  }
  .content_html{
    padding: 15px 5px;
    display: none;
  }
  .content_html_show{
    padding: 15px 5px;
    display: block;
  }
  .custom-file-input, .custom-select{
    cursor: pointer !important;
  }
  .add_users, .add_users_file, .add_distributors{
    padding: 15px 5px;
  }
  .sendEmails{
    float: left;
    margin: 20px 0px;
  }
  .btn_selected{
    background-color: #28a745 !important;
    color: white !important;
  }
  .chart-container {
    height: 90vh;
    width: 100%;
    margin: 20px 0px;
  }
  .chart {
    height: 90vh;
    width: 100%;
  }
  .selected {
    background-color: #1da5df;
  }
  .view_total{
    margin:5px auto 5px 0px; 
    background-color:#1da5df;
    padding: 5px 30px;
    border-radius: 3px;
  }
  
  /* Fuentes */
  @font-face {
    font-family: "GothamBookItalic";
    src: url("./../../../../../assets/font/GothamBookItalic.ttf");
    font-display: swap;
  }
  @font-face {
    font-family: "GothamBoldItalic";
    src: url("./../../../../../assets/font/GothamBoldItalic.ttf");
    font-display: swap;
  }
  @font-face {
    font-family: "Gotham-UltraItalic";
    src: url("./../../../../../assets/font/Gotham-UltraItalic.ttf");
    font-display: swap;
  }

  /* MOBILE */
  @media (max-width: 767px) {
    .chart-container, .chart {
      height: 500px !important;
      width: 100% !important;
    }
  }
</style>